import type { Brief as BriefData, Suite } from '../../data/types/platform';

export interface BriefProps {
  brief: BriefData;
  suites: Suite[];
  goToSystem: (systemId: string, moduleId?: string) => void;
}

export function Brief({ brief, suites, goToSystem }: BriefProps) {
  return (
    <section className="brief">
      <div className="b-eyebrow">
        <span className="b-dot" />
        תדריך הבוקר
        <span className="b-sep">·</span>
        <span>{brief.date}</span>
        <span className="b-sep">·</span>
        <span className="b-edition">{brief.edition}</span>
      </div>
      <div className="b-grid">
        <div>
          <h1>{brief.headline}</h1>
          <p className="b-body">{brief.body}</p>
        </div>
        <div className="b-signals">
          <div className="bs-head">סיגנלים, חתך רוחבי</div>
          {brief.signals.map((s, i) => {
            const suite = suites.find((x) => x.id === s.suite);
            return (
              <div className="bs-row" key={i} onClick={() => goToSystem(s.suite)}>
                <div className="bs-suite">{suite?.he}</div>
                <div className="bs-label">{s.he}</div>
                <div className="bs-v">{s.v}</div>
                <div className={'bs-delta ' + s.tone}>{s.delta}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
